import {
  SIDE_NAV_LIGHT,
  NAV_TYPE_SIDE,
  DIR_LTR,
} from "constants/ThemeConstant";

export const APP_NAME = "C3M";
export const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

// SaaS Configuration
export const ENABLE_SAAS_FEATURE =
  process.env.REACT_APP_ENABLE_SAAS_FEATURE === "true";
export const DEFAULT_ORGANIZATION_ID = parseInt(
  process.env.REACT_APP_DEFAULT_ORGANIZATION_ID || "1",
  10,
);
export const ENABLE_PROJECT_TIMELINE =
  process.env.REACT_APP_ENABLE_PROJECT_TIMELINE === "true";

export const ENABLE_DEVIATIONS =
  process.env.REACT_APP_ENABLE_DEVIATIONS === "true";

// Hide Terms & Conditions, Privacy Policy and Need Help based on env flag | By vipul.singh@velsof.com on 29-04-2026
export const HIDE_TC_PP_AND_SUPPORT =
  process.env.REACT_APP_HIDE_TC_PP_AND_SUPPORT === "true";

export const APP_PREFIX_PATH = "/app";
export const AUTH_PREFIX_PATH = "/auth";
export const REDIRECT_URL_KEY = "redirect";
export const AUTHENTICATED_ENTRY = `${APP_PREFIX_PATH}/contracts/contract-lists`;
export const UNAUTHENTICATED_ENTRY = "/login";

export const LOGIN_ROUTE = `${AUTH_PREFIX_PATH}/login`;
export const REGISTER_ROUTE = `${AUTH_PREFIX_PATH}/register`;
export const FORGOT_PASSWORD_ROUTE = `${AUTH_PREFIX_PATH}/forgot-password`;
export const RESET_PASSWORD_ROUTE = `/reset-password`;

export const DASHBOARD_PATH = `${APP_PREFIX_PATH}/dashboards/default`;
export const USER_MANAGEMENT_PATH = `${APP_PREFIX_PATH}/user-management`;
export const LAW_FIRM_USER_MANAGEMENT_PATH = `${APP_PREFIX_PATH}/law-firm-user-management`;
export const ORGANISATION_MANAGEMENT_PATH = `${APP_PREFIX_PATH}/organisation-management`;
export const CONTRACT_LIST_PATH = `${APP_PREFIX_PATH}/contracts/contract-lists`;
export const ADD_NEW_CONTRACT_PATH = `${APP_PREFIX_PATH}/contracts/add`;
export const EDIT_CONTRACT_PATH = `${APP_PREFIX_PATH}/contracts/:contractId/edit`;
export const CONTRACT_DETAILS_PATH = `${APP_PREFIX_PATH}/contracts/:contractId/view`;
export const OBLIGATION_DETAILS_PATH = `${APP_PREFIX_PATH}/contracts/:contractId/obligations/:obligationId`;
export const TASK_DETAILS_PATH = `${APP_PREFIX_PATH}/contracts/:contractId/tasks/:taskId`;
export const USER_PROFILE = `${APP_PREFIX_PATH}/profile`;
export const NEW_PASSWORD = `${APP_PREFIX_PATH}/new-password`;
export const SCHEDULE_EXTENSION = `${APP_PREFIX_PATH}/schedule-extensions/:extensionId`;
export const SUSPENSTION_EVENT_DETAILS_PATH = `${APP_PREFIX_PATH}/contracts/:contractId/unclassified-event/:eventId`;
export const ROLE_MANAGEMENT_PATH = `${APP_PREFIX_PATH}/role-management`;
export const PROJECT_REMINDER_DETAILS_PATH = `${APP_PREFIX_PATH}/contracts/:contractId/project-reminders/:reminderId`;


export const THEME_CONFIG = {
  navCollapsed: false,
  sideNavTheme: SIDE_NAV_LIGHT,
  locale: "en",
  navType: NAV_TYPE_SIDE,
  topNavColor: "#3e82f7",
  headerNavColor: "",
  mobileNav: false,
  currentTheme: "light",
  direction: DIR_LTR,
  blankLayout: false,
};

// Document upload - allowed MIME types
export const ALLOWED_DOCUMENT_MIME = {
  ".pdf": "application/pdf",
  ".doc": "application/msword",
  ".docx":
    "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
  ".xls": "application/vnd.ms-excel",
  ".xlsx": "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  ".ppt": "application/vnd.ms-powerpoint",
  ".pptx":
    "application/vnd.openxmlformats-officedocument.presentationml.presentation",
  ".csv": "text/csv",
  ".txt": "text/plain",
};

export const ALLOWED_IMAGE_TYPE = {
  ".jpg": "image/jpeg",
  ".jpeg": "image/jpeg",
  ".png": "image/png",
  ".webp": "image/webp",
};

export const ALLOWED_VIDEO_TYPE = {
  ".mp4": "video/mp4",
  ".mov": "video/quicktime",
  ".avi": "video/x-msvideo",
  ".mkv": "video/x-matroska",
  ".webm": "video/webm",
  ".m4v": "video/x-m4v",
};
export const ALLOWED_FILE_IN_TASK_CREATION = {
  ...ALLOWED_DOCUMENT_MIME,
  ...ALLOWED_IMAGE_TYPE,
  ...ALLOWED_VIDEO_TYPE,
}; //File allowed to upload in task creation
export const ALL_DOCUMENT_ALLOWED = {
  ...ALLOWED_DOCUMENT_MIME,
  ...ALLOWED_IMAGE_TYPE,
  ...ALLOWED_VIDEO_TYPE,
}; //File allowed to upload in task creation

// Image paths configuration
export const IMAGE_PATHS = {
  // Logos
  LOGO: "/img/logo.png",
  LOGO_WHITE: "/img/logo-white.png",
  LOGO_SM: "/img/logo-sm.png",
  LOGO_SM_WHITE: "/img/logo-sm-white.png",

  // Auth/Login images
  LOGIN_ILLUSTRATION: require("../assets/images/login-illustration.png"),
  C3M_LOGO: require("../assets/images/c3m-logo.png"),

  // Empty states
  NO_DATA_FOUND: "/img/no_data_found.svg",

  // Background images
  AUTH_BACKGROUND: "/img/others/img-17.jpg",
  ERROR_PAGE_1: "/img/others/img-20.png",
  ERROR_PAGE_2: "/img/others/img-21.png",

  // Directories for dynamic paths
  AVATARS_DIR: "/img/avatars",
  FLAGS_DIR: "/img/flags",
  OTHERS_DIR: "/img/others",
  THUMBS_DIR: "/img/thumbs",
};
